// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dvjjinuwfbfqcoewnrcf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR2amppbnV3ZmJmcWNvZXducmNmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUxNDMyMzEsImV4cCI6MjA3MDcxOTIzMX0.ggVAVFJ8fQih0-g8ptl4rotcYffs67ATki8OZlVAR-E";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});